import { useReducedMotion } from "motion/react"
import { cn } from "@strivelabs/ui-core"
import { COMPOSER_MODE_ACCENT } from "./tones"

/** Number of bars rendered; the newest `levels` fill the rightmost bars. */
const BAR_COUNT = 24

export interface ComposerWaveformProps {
  /** Recent audio amplitudes in 0..1, oldest to newest. */
  levels: number[]
  /** When false, bars render flat (idle/transcribing). */
  active: boolean
  className?: string
}

/**
 * Presentational audio waveform. Maps the most recent `levels` to bar heights;
 * under reduced motion the bars stay flat instead of tracking `levels`.
 */
export const ComposerWaveform = ({ levels, active, className }: ComposerWaveformProps) => {
  const reduceMotion = useReducedMotion()
  const bars = Array.from(
    { length: BAR_COUNT },
    (_, index) => levels[levels.length - BAR_COUNT + index] ?? 0,
  )
  return (
    <div className={cn("flex h-7 items-center gap-1", className)} aria-hidden="true">
      {bars.map((level, index) => {
        const height = active && !reduceMotion ? Math.max(12, Math.min(100, level * 100)) : 12
        return (
          <span
            key={index}
            data-waveform-bar
            className="w-1 rounded-full transition-[height] duration-100 motion-reduce:transition-none"
            style={{ height: `${height}%`, backgroundColor: COMPOSER_MODE_ACCENT }}
          />
        )
      })}
    </div>
  )
}
